import React from 'react';
import FAQItem from '../components/FAQItem';
import './styles/FAQPage.css';
import Navbar from '../components/home/Navbar';
import Footer from '../components/Footer'
const faqs = [
  {
    question: 'Quelles sont les conditions pour obtenir un prêt ?',
    answer: `Conditions d'octroi du prêt :
- Ne pas dépasser l'âge de 60 ans.
- Ne pas accorder de prêt à plus d'un membre d'une même famille.
- Vérification de la viabilité et de la rentabilité du projet.
- Attribution de prêts de renouvellement à ceux qui ont respecté les délais de remboursement et qui continuent d'exercer leur activité.
- Respect de l'ordre chronologique en fonction de la date de soumission des demandes.`
  },
  {
    question: 'Quels sont les documents requis pour obtenir un prêt ?',
    answer: `Documents requis pour obtenir un prêt :
1. Une copie de la carte d'identité nationale.
2. Une demande de prêt.
3. Remplir le formulaire numéro 1.`
  },
  {
    question: 'Quel est le montant maximal du prêt que je peux obtenir ?',
    answer: 'Le montant maximal du prêt que vous pouvez obtenir est compris entre 1000 DT et 5000 DT.'
  },
  {
    question: 'Quelle est la durée maximale de remboursement d\'un prêt ?',
    answer: 'La durée maximale de remboursement d\'un prêt est de 24 à 36 mois.'
  },
  {
    question: 'Quels sont les taux d\'intérêt appliqués aux prêts ?',
    answer: 'Le taux d\'intérêt appliqué aux prêts est de 5%.'
  }
];

const FAQPage = () => {
  return (
    <div><Navbar />
<div className="faq-page-container">
      
      <div className="faq-page">
        <h1>FAQ</h1>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
            />
          ))}
        </div>
      </div>
      </div>
    </div>
  );
};

export default FAQPage;
